module.exports = __webpack_public_path__ + "files/b55d98414ffc341f17213f9265752107.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/roboto-bolditalic-webfont.woff
// module id = 911
// module chunks = 60